import { IconSlash } from "@tabler/icons-react";
import { Link } from "@tanstack/react-router";
import clsx from "clsx";

interface HeaderProps {
	title?: string;
	action?: React.ReactNode;
}

export function Header({ title, action }: HeaderProps) {
	return (
		<div className="flex flex-row justify-center h-[40px] w-full border-b border-border/50">
			<div
				className={clsx(
					"flex flex-row items-center w-full w-ba px-6 max-w-full",
				)}
			>
				<div className="inline-flex flex-col w-auto">
					<div className="inline-flex flex-row items-center w-auto">
						<Link
							to="/"
							className="inline-flex text-base text-foreground/70 hover:text-foreground-dark"
						>
							Dashboard
						</Link>
						{title && (
							<>
								<span className="text-foreground/30">
									<IconSlash size={14} stroke={2} />
								</span>
								<Link
									to="/"
									className="inline-flex text-base text-foreground/70 hover:text-foreground-dark"
								>
									{title && title}
								</Link>
							</>
						)}
					</div>
				</div>
				{action && (
					<div className="inline-flex flex-row w-auto ml-auto">{action}</div>
				)}
			</div>
		</div>
	);
}
